import React, { Component, ErrorInfo, ReactNode } from 'react';
import Translate from '@/components/Translate';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import './style.scss';

interface Props {
  children?: ReactNode;
}
interface State {
  hasError: boolean;
  errorMessage?: string;
  stack?: string;
}
class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    errorMessage: '',
    stack: '',
  };
  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: true,
      errorMessage: error?.message,
      stack: error?.stack,
    });
  }
  handleRefresh = () => {
    window.location.reload();
  };
  handleSplitStack(stack: string | undefined): string[] {
    return stack ? stack.split('\n   ') : [''];
  }
  renderErrorContent() {
    const { stack } = this.state;
    const splitStack = this.handleSplitStack(stack);

    return (
      <div
        style={{
          flexBasis: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <h1
          style={{
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Translate content='ERROR_OCCURRED' />
        </h1>
        <h3
          style={{
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'center',
            color: 'orange',
          }}
        >
          {splitStack[0]}
        </h3>
        <div style={{ flexBasis: '100%' }}>
          <ul
            style={{
              border: '1px solid orange',
              borderRadius: '1rem',
              direction: 'ltr',
              margin: '1rem',
              padding: '15px',
            }}
          >
            {splitStack.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <div
          style={{
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button style={{ margin: '1rem' }}>
            <Link to='/'>
              <Translate content='BACK_TO_HOME' />
            </Link>
          </Button>
          <Button style={{ margin: '1rem' }} onClick={this.handleRefresh}>
            <Translate content='REFRESH' />
          </Button>
        </div>
      </div>
    );
  }
  render() {
    return this.state.hasError
      ? this.renderErrorContent()
      : this.props.children;
  }
}

export default ErrorBoundary;
